import { Dictionary } from "@insite/client-framework/Common/Types";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

export let themeCollection: Dictionary<any> = {};

export const setThemeCollection = <T>(themes: Dictionary<any>, defaultThemeName: T) => {
    Object.entries(themes).forEach(([key, theme]) => {
        theme.name = key;
    });

    if (typeof defaultThemeName === "string") {
        const defaultTheme = themes[defaultThemeName];

        if (defaultTheme) {
            setPostStyleGuideTheme(defaultTheme);
        }
    }

    themeCollection = themes;

    return themeCollection;
};
